import styled from 'styled-components';

const StyledModalCloseButtonWrapper = styled.button`
  background: #f7f8f8;
  border-radius: 50%;
  display: flex;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  border: none;
  cursor: pointer;
`;

export { StyledModalCloseButtonWrapper };
